<div class="home-container">
  <app-profile class="profile"></app-profile>>
  <div class="main-container">
    <app-image-carousel class="carousel"></app-image-carousel>
    <app-form-buttons class="buttons"></app-form-buttons>
  </div>
</div>
